export enum LocalStorageKeyType {
  Test = 'test',
  WelcomeFieldAi = 'welcome-field-ai',
}
